import { ReactNode } from 'react';
import { Checkbox } from '@/components/ui/checkbox';
import { Label } from '@/components/ui/label';

interface LegalAcceptanceCheckboxProps {
  id: string;
  checked: boolean;
  onCheckedChange: (checked: boolean) => void;
  children: ReactNode;
  disabled?: boolean;
}

/**
 * Reusable consent checkbox for legal acceptances.
 * The label content (children) should include the clickable links to the legal documents.
 */
export function LegalAcceptanceCheckbox({
  id,
  checked,
  onCheckedChange,
  children,
  disabled,
}: LegalAcceptanceCheckboxProps) {
  return (
    <div className="flex items-start gap-2">
      <Checkbox
        id={id}
        checked={checked}
        onCheckedChange={(v) => onCheckedChange(v === true)}
        disabled={disabled}
        className="mt-0.5"
      />
      <Label
        htmlFor={id}
        className="text-xs text-muted-foreground leading-snug cursor-pointer"
      >
        {children}
      </Label>
    </div>
  );
}
